/**
 * @generated SignedSource<<81e3902a7383a78e46e4aa0fab3733e0>>
 * @relayHash 5abfb5b1a2895e117855a1cbb6e88a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2dfbb210299b94779651562128108ca6738550110e209f2a2374cb596001032

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssignedQuery$variables = {
  first?: number | null;
  isEnabled: boolean;
  jiraIssueQuery: string;
  pullRequestQuery: string;
  queryContext: string;
  townsquareQuery: string;
};
export type AssignedQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomeAssignedList">;
};
export type AssignedQuery = {
  response: AssignedQuery$data;
  variables: AssignedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraIssueQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pullRequestQuery"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "townsquareQuery"
},
v6 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v7 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "url"
},
v10 = {
  "kind": "ScalarField",
  "name": "value"
},
v11 = [
  (v10/*: any*/)
],
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "creationDate"
  },
  {
    "kind": "ScalarField",
    "name": "editDate"
  },
  (v13/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "iconData"
},
v17 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v15/*: any*/),
    (v13/*: any*/)
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v19 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v20 = {
  "kind": "ScalarField",
  "name": "picture"
},
v21 = [
  (v13/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "AppUser"
},
v23 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "CustomerUser"
},
v24 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": [
      (v15/*: any*/),
      (v20/*: any*/),
      (v13/*: any*/)
    ]
  },
  {
    "args": (v12/*: any*/),
    "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
    "kind": "LinkedField",
    "name": "linkedUsers",
    "plural": false,
    "selections": [
      {
        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v20/*: any*/),
                  (v19/*: any*/),
                  (v13/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              },
              (v22/*: any*/),
              (v23/*: any*/)
            ]
          },
          (v13/*: any*/)
        ]
      }
    ],
    "storageKey": "linkedUsers(first:1)"
  }
],
v25 = [
  {
    "concreteType": "GraphStoreCypherQueryV2Edge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "GraphStoreCypherQueryV2Node",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphStoreCypherQueryV2Column",
            "kind": "LinkedField",
            "name": "columns",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": "goalState",
                                "concreteType": "TownsquareGoalState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v11/*: any*/)
                              },
                              {
                                "alias": "goalCreationDate",
                                "kind": "ScalarField",
                                "name": "creationDate"
                              },
                              {
                                "alias": "goalUpdates",
                                "args": (v12/*: any*/),
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v14/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              },
                              (v13/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": "goalStatus",
                                "concreteType": "TownsquareStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "score"
                                  }
                                ]
                              },
                              (v16/*: any*/),
                              (v17/*: any*/)
                            ],
                            "type": "TownsquareGoal"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": "projectState",
                                "concreteType": "TownsquareProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "label"
                                  }
                                ]
                              },
                              {
                                "alias": "projectCreationDate",
                                "kind": "ScalarField",
                                "name": "creationDate"
                              },
                              {
                                "alias": "projectUpdates",
                                "args": (v12/*: any*/),
                                "concreteType": "TownsquareProjectUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareProjectUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v14/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              },
                              (v13/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/)
                            ],
                            "type": "TownsquareProject"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "mercuryName"
                                          },
                                          (v13/*: any*/)
                                        ]
                                      },
                                      (v13/*: any*/),
                                      (v15/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraDateTimePickerField",
                                "kind": "LinkedField",
                                "name": "updatedField",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "dateTime"
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v19/*: any*/),
                                  (v13/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "summary"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              (v13/*: any*/),
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "small"
                                          }
                                        ]
                                      },
                                      (v13/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraProjectField",
                                "kind": "LinkedField",
                                "name": "projectField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v18/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastUpdate"
                              },
                              (v13/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": (v24/*: any*/)
                              },
                              {
                                "concreteType": "ExternalReviewer",
                                "kind": "LinkedField",
                                "name": "reviewers",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "approvalStatus"
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": (v24/*: any*/)
                                  }
                                ]
                              },
                              {
                                "concreteType": "ExternalProvider",
                                "kind": "LinkedField",
                                "name": "provider",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/)
                                ]
                              }
                            ],
                            "type": "ExternalPullRequest"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "Node",
                            "abstractKey": "__isNode"
                          },
                          (v22/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "AtlassianAccountUser"
                          },
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsFeatureFlag"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsOperationsComponentDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsOperationsIncidentDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsProjectDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsPullRequestDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsRepository"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsSecurityVulnerabilityDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraAutodevJob"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraConfluenceRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraCustomRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraIssueRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraWebRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "TeamCustomFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "TeamType"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "ThirdPartyUser"
                          }
                        ]
                      },
                      (v13/*: any*/)
                    ],
                    "type": "GraphStoreCypherQueryV2AriNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "GraphStoreCypherQueryV2TimestampObject"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AssignedQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "jiraIssueQuery",
                "variableName": "jiraIssueQuery"
              },
              {
                "kind": "Variable",
                "name": "pullRequestQuery",
                "variableName": "pullRequestQuery"
              },
              (v7/*: any*/),
              {
                "kind": "Variable",
                "name": "townsquareQuery",
                "variableName": "townsquareQuery"
              }
            ],
            "kind": "FragmentSpread",
            "name": "HomeAssignedList"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssignedQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "alias": "townsquare",
                "args": [
                  (v6/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "townsquareQuery"
                  },
                  (v7/*: any*/)
                ],
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": (v25/*: any*/)
              },
              {
                "alias": "jiraIssue",
                "args": [
                  (v6/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "jiraIssueQuery"
                  },
                  (v7/*: any*/)
                ],
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": (v25/*: any*/)
              },
              {
                "alias": "pullRequest",
                "args": [
                  (v6/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "pullRequestQuery"
                  },
                  (v7/*: any*/)
                ],
                "concreteType": "GraphStoreCypherQueryV2Connection",
                "kind": "LinkedField",
                "name": "cypherQueryV2",
                "plural": false,
                "selections": (v25/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d2dfbb210299b94779651562128108ca6738550110e209f2a2374cb596001032",
    "metadata": {},
    "name": "AssignedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a3fb518ad318e4162d01d80370351499";

export default node;
